<template>
    <div class="campo-form">
        <div class="label-container">
            <label>{{ label }}<span style="color: #bb2a17" v-if="required">*</span></label>
            <slot name="acoes"></slot>
        </div>
        <div class="input-wrapper">
            <InputText
                class="input"
                :placeholder="placeholder"
                :name="name"
                v-model="inputValue"
                @keydown="onKeydown"
                @update:modelValue="emit('update:modelValue', $event)"
            />
            <i v-if="label !== 'CPF'" class="material-symbols-outlined">expand</i>
        </div>
    </div>
</template>

<script setup>
import { ref, defineEmits, defineProps, watch } from 'vue';

const props = defineProps({
    label: String,
    placeholder: String,
    name: String,
    helpText: String,
    modelValue: String,
    required: Boolean,
    length: Number,
    timestampLimpeza: Number,
});

const emit = defineEmits(['update:modelValue']);
const inputValue = ref(props.modelValue || '');

watch(
    () => props.timestampLimpeza,
    (newValue, oldValue) => {
        if (newValue !== oldValue) {
            inputValue.value = '';
        }
    }
);

const onKeydown = (event) => {
    if (!props.length) {
        return;
    }

    const valorAtual = event.target.value || '';

    if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(event.key)) {
        return;
    }

    if (valorAtual.length >= props.length) {
        event.preventDefault();
    }
};
</script>

<style scoped lang="scss">
.campo-form {
    width: 100%;

    .input {
        width: 100%;
    }

    .label-container {
        padding-bottom: 4px;
        display: flex;
        align-items: center;
        gap: 10px;
        font-weight: 700;
        color: #252529;
    }
    .input-wrapper {
        position: relative;
        width: 100%;
    }
    .material-symbols-outlined {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        cursor: grab;
        color: #adb5bd;
    }
}
</style>
